import { RefundRequest } from "../../types";
import { isRequestRefunded, toSydneyDate } from "../../utils";

export const calcMaxRefundInDays = (refundRequest: RefundRequest, calcFromDate?: Date | string): number | null => {
  const returnedDate = refundRequest.returnedAt;

  if (isRequestRefunded(refundRequest.status) || !returnedDate) {
    return null;
  }

  // Must refund by 5 days from returned date
  const startDate = toSydneyDate(returnedDate).add(5, "days");
  const endDate = toSydneyDate(calcFromDate || new Date());
  return startDate.diff(endDate, "days");
};
